export default "ui-sprite{display:none}\n";